/**
 * Die Konten, auf die nur CoKo bucht (2.13 Abschnitt 17.5, R1427):
 * „Rundungsdifferenzen“ und die Währungsumrechnungsrücklage.
 *
 * Dieselbe Liste wie `Festkonten.NurCoko` im Server, der eine Buchung und
 * eine Kontenzuordnung darauf abweist; `Festkonten.test.ts` hält beide gleich.
 * Hier steht sie, damit die Oberfläche sie gar nicht erst anbietet.
 */
import { istNurCokoImKatalog, istStatistikkontoImKatalog } from './sprache'

export const NUR_COKO: ReadonlySet<string> = new Set(['KTO-RUNDUNG', 'KTO-2250'])

/**
 * Was zur Wahl steht, wo gebucht oder zugeordnet wird — ohne die technischen
 * Konten (R1427). Eine Stelle für jede solche Auswahl: Buchungsmaske,
 * Kontenzuordnung, Zuordnung im Datenimport, Vorschläge der Datenquelle.
 * Wo eingestellt statt gebucht wird — Konzernhandbuch, Konsolidierungsschritt —,
 * bleiben sie wählbar.
 */
export function ohneTechnische<T>(eintraege: readonly T[], schluessel: (e: T) => string): T[] {
  // Dazu jedes eigene Konto einer Stichtagskursanpassung, das der Katalog
  // nennt (2.6 Abschnitt 2.14, R1656) — es entsteht erst mit dem Haken.
  return eintraege.filter((e) => !NUR_COKO.has(schluessel(e)) && !istNurCokoImKatalog(schluessel(e)))
}

/**
 * Was zur Wahl steht, wo ein Konto zugeordnet oder eingestellt wird — ohne die
 * Statistikkonten (2.1 Abschnitt 3.6, R1734). Ein Statistikkonto steht nur in
 * der Buchungsmaske zur Wahl: Eine Lieferung darf es nicht tragen (R1732), und
 * die Konsolidierung bebucht es nie (R1731). Eine Stelle für jede solche
 * Auswahl; `Statistikauswahl.test.ts` meldet jede, die sie nicht fragt.
 */
export function ohneStatistikkonten<T>(eintraege: readonly T[], schluessel: (e: T) => string): T[] {
  return eintraege.filter((e) => !istStatistikkontoImKatalog(schluessel(e)))
}
